import React from "react";
import {ServicesContainer, ServicesH1, ServicesWrapper, ServicesCard, ServicesIcon, ServicesH2, ServicesP} from "./ServicesElements";
import Icon1 from "../../images/icon1.png"
import Icon2 from "../../images/icon2.png"
import Icon3 from "../../images/icon3.png"
import Icon4 from "../../images/icon4.png"
import Icon5 from "../../images/icon5.png"
import Icon6 from "../../images/icon6.png"

const Services = () => {
  return (
    <ServicesContainer id="services">
      <ServicesH1>Use Cases</ServicesH1>
      <ServicesWrapper>
        <ServicesCard>
          <ServicesIcon src={Icon1} />
          <ServicesH2>Personalized Learning Paths</ServicesH2>
          <ServicesP>
          AI analyzes student performance data to create customized learning plans.
          </ServicesP>
        </ServicesCard>
        <ServicesCard>
          <ServicesIcon src={Icon2} />
          <ServicesH2>Virtual Tutors and Chatbots</ServicesH2>
          <ServicesP>
          Provides real-time assistance and explanations to students 24/7.
          </ServicesP>
        </ServicesCard>
        <ServicesCard>
          <ServicesIcon src={Icon3} />
          <ServicesH2>Grading and Assessment</ServicesH2>
          <ServicesP>
          Automates grading of essays, assignments, and exams with detailed feedback.
          </ServicesP>
        </ServicesCard>
        <ServicesCard>
          <ServicesIcon src={Icon4} />
          <ServicesH2>Customer Support Automation</ServicesH2>
          <ServicesP>
          Chatbots handle customer inquiries and resolve common issues efficiently.
          </ServicesP>
        </ServicesCard>
        <ServicesCard>
          <ServicesIcon src={Icon5} />
          <ServicesH2>Human Resources Management</ServicesH2>
          <ServicesP>
          Streamlines HR processes by generating job descriptions and screening resumes.
          </ServicesP>
        </ServicesCard>        
        <ServicesCard>
          <ServicesIcon src={Icon6} />
          <ServicesH2>Product Design and Prototyping</ServicesH2>
          <ServicesP>
          Assists in designing and prototyping new products with multiple design options.
          </ServicesP>
        </ServicesCard>
      </ServicesWrapper>
    </ServicesContainer>
  );
};

export default Services;
